import React, { useState } from 'react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SimpleField from '../Inputs/MandatoryField';
import {
    Checkbox,
    FormControlLabel,
    FormHelperText,
    Grid,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@material-ui/core';
import { PrimaryButton } from '../Inputs/Buttons/ButtonModal';
import CustomEditor from '../CkEditor';
import { GreenCheckbox } from '../Inputs/Checkbox';
import { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { useToast } from '../../Hooks/useToast';
import moment from 'moment';
import { downloadUploadedFile } from '../../Services/FileUploaderService';
import { getConfigIdFromName } from '../GenericFileUploader/FileUploaderConfig';
import DialogComp from '../../Dialog/DialogComp';
import SingleDocumentViewer from '../GenericFileUploader/DocumentViewer';
import { GetJobEmailData } from '../../Services/InternalUser/JOB/jobItemsService';

const VehicleStyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        fontWeight: 700,
        padding: 5,
        backgroundColor: 'lightgrey'
    },
    body: {
        fontSize: 14,
        padding: 5
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover
        }
    }
}))(TableRow);

const EmailTemplate = ({
    initialEmail = '',
    initialSubject = '',
    initialBody = '',
    getEmailValues,
    isProforma = false,
    scheduleDocs,
    handlescheduleDocsChange,
    jobDocs,
    handlejobDocsChange,
    salesInvoiceStatus,
    scheduleJobID,
    customerID
}) => {
    const [state, setState] = useState({ errors: {} });
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [emaileventdocument, setEmaileventdocument] = useState('');
    const [emaileventdocumentIsReq, setemaileventdocumentIsReq] = useState(false);
    const [emailIsReq, setemailIsReq] = useState(false);
    const [sendAuthorityEmail, SetSendAuthorityEmail] = useState(true);
    const { showToastSuccess, showToastError } = useToast();

    useEffect(() => {
        let fetchData = async () => {
            try {
                let res = await GetJobEmailData(scheduleJobID, customerID, 'Invoice');
                if (res.success) {
                    let data = res.data.data[0];
                    setEmail(data.authorityEmail);
                    setSubject(data.authoritySub);
                    setBody(data.authorityBody);
                } else {
                    setEmail('');
                    setSubject('');
                    setBody('');
                }
            } catch (error) {
                showToastError('Failed to fetch email data');
            }
        };
        return fetchData();
    }, [scheduleJobID, customerID, sendAuthorityEmail]);

    useEffect(() => {
        let scheduleDocsisReq = salesInvoiceStatus == 'I' && scheduleDocs.some((m) => m.sendToCustomer);
        let jobDocsisReq = salesInvoiceStatus == 'P' && jobDocs.some((m) => m.sendToCustomer);
        setemaileventdocumentIsReq(scheduleDocsisReq);
        setemailIsReq(jobDocsisReq);
    }, [scheduleDocs, jobDocs]);

    const handleSubjectChange = (e) => {
        setSubject(e.target.value);
    };
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };
    const handleEmaileventdocumentChange = (e) => {
        setEmaileventdocument(e.target.value);
    };
    const handleSendAuthorityEmail = (e) => {
        SetSendAuthorityEmail(e.target.checked);
    };

    const handleBodyChange = (event, editor) => {
        const data = editor.getData();
        setBody(data);
    };

    const validations = () => {
        let formIsValid = true;
        let errors = {};
        if (emailIsReq && !email.trim()) {
            errors.email = 'This field is required';
            formIsValid = false;
        }
        if (emaileventdocumentIsReq && !emaileventdocument.trim()) {
            errors.emaileventdocument = 'This field is required';
            formIsValid = false;
        }

        setState((st) => ({ ...st, errors: errors }));
        return formIsValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // if ((emailIsReq && !email.trim()) || (emaileventdocumentIsReq && !emaileventdocument.trim())) {
        //     showToastError('Please fill all required fields');
        //     return;
        // }
        if (validations()) {
            console.log('handleSubmit called');
            getEmailValues({
                authorityEmail: email,
                authoritySub: subject,
                authorityBody: body,
                sendAuthorityEmail: sendAuthorityEmail,
                emaileventdocument: emaileventdocument
            });
        }
    };

    const ViewDownloadFile = (row, screenName) => async (e) => {
        setState((st) => ({ ...st, showDocument: true }));

        let success = await downloadUploadedFile(
            getConfigIdFromName(screenName),
            row.recordId,
            row.uniqueFileName,
            `${row.fileName}${row.fileExt}`,
            false,
            false,
            row.fileExt
        );
        if (success) {
            setState((st) => ({ ...st, imageList: success, slectedFileExt: row.fileExt, slectedFileName: row.fileName }));
        } else {
            showToastError(`Something went wrong, can't download file.`);
        }
    };

    const hideModal = (type) => () => {
        setState((st) => ({ ...st, [type]: false, fileToAction: undefined, imageList: '', slectedFileName: '', slectedFileExt: '' }));
    };

    return (
        <div style={{ padding: '10px' }}>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    {/* <Grid item xs={12}>
                        <FormControlLabel
                            control={<GreenCheckbox onChange={handleSendAuthorityEmail} checked={sendAuthorityEmail} />}
                            label={'Send Authority Email'}
                        />
                    </Grid> */}
                    {salesInvoiceStatus == 'P' && (
                        <Grid item xs={12}>
                            <InputLabel shrink required={emailIsReq} error={emailIsReq}>
                                Proforma Email
                            </InputLabel>
                            <SimpleField value={email} onChange={handleEmailChange} autoFocus={true} />
                            <FormHelperText error>{state.errors?.email}</FormHelperText>
                        </Grid>
                    )}
                    {salesInvoiceStatus == 'I' && (
                        <Grid item xs={12}>
                            <InputLabel shrink required={emaileventdocumentIsReq} error={emaileventdocumentIsReq}>
                                Document Email
                            </InputLabel>
                            <SimpleField type="email" value={emaileventdocument} name="sendEmailTo" onChange={handleEmaileventdocumentChange} />
                            <FormHelperText error>{state.errors?.emaileventdocument}</FormHelperText>
                        </Grid>
                    )}
                    {salesInvoiceStatus == 'P' && (
                        <>
                            <Grid item xs={12}>
                                <InputLabel shrink>Subject</InputLabel>
                                <SimpleField type="text" value={subject} onChange={handleSubjectChange} required />
                            </Grid>
                            <Grid item xs={12}>
                                <InputLabel shrink>Body</InputLabel>
                                <CustomEditor editor={ClassicEditor} data={body || ''} onChange={handleBodyChange} />
                            </Grid>
                        </>
                    )}
                    {jobDocs.length > 0 && salesInvoiceStatus == 'P' && (
                        <Grid item xs={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle1" color="secondary">
                                        Job Documents
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TableContainer
                                        style={{
                                            border: '1px solid rgba(0,0,0,0.2)',
                                            maxHeight: '300px'
                                        }}
                                        className="custom-scroll"
                                    >
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <StyledTableRow>
                                                    <VehicleStyledTableCell width={12}>Email?</VehicleStyledTableCell>
                                                    <VehicleStyledTableCell>File Name</VehicleStyledTableCell>
                                                    {/* <VehicleStyledTableCell>Document</VehicleStyledTableCell> */}
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {jobDocs.map((m, i) => {
                                                    return (
                                                        <StyledTableRow>
                                                            <VehicleStyledTableCell>
                                                                <Checkbox
                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                                    name="sendToCustomer"
                                                                    onChange={() => handlejobDocsChange(i)}
                                                                    checked={m.sendToCustomer}
                                                                />
                                                            </VehicleStyledTableCell>
                                                            <VehicleStyledTableCell>
                                                                {/* {m.fileName} */}
                                                                <div>
                                                                    <a href="javascript:0" onClick={ViewDownloadFile(m, 'JobScreen')} style={{}}>
                                                                        {m.fileName}
                                                                    </a>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        fontSize: '12px',
                                                                        color: 'grey',
                                                                        verticalAlign: ''
                                                                    }}
                                                                >
                                                                    {m.uploadedBy} @ {moment(m.uploadedAt).format('LLL')} {`(${m.fileSize})`}
                                                                </div>
                                                            </VehicleStyledTableCell>
                                                            {/* <VehicleStyledTableCell>{m.docName}</VehicleStyledTableCell> */}
                                                        </StyledTableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    {scheduleDocs.length > 0 && salesInvoiceStatus == 'I' && (
                        <Grid item xs={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle1" color="secondary">
                                        Schedule Documents
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TableContainer
                                        style={{
                                            border: '1px solid rgba(0,0,0,0.2)',
                                            maxHeight: '300px'
                                        }}
                                        className="custom-scroll"
                                    >
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <StyledTableRow>
                                                    <VehicleStyledTableCell width={12}>Email?</VehicleStyledTableCell>
                                                    <VehicleStyledTableCell>File Name</VehicleStyledTableCell>
                                                    {/* <VehicleStyledTableCell>Document</VehicleStyledTableCell> */}
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {scheduleDocs.map((m, i) => {
                                                    return (
                                                        <StyledTableRow>
                                                            <VehicleStyledTableCell>
                                                                <Checkbox
                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                                    name="sendToCustomer"
                                                                    onChange={() => handlescheduleDocsChange(i)}
                                                                    checked={m.sendToCustomer}
                                                                />
                                                            </VehicleStyledTableCell>
                                                            <VehicleStyledTableCell>
                                                                {' '}
                                                                <div>
                                                                    <a
                                                                        href="javascript:0"
                                                                        onClick={ViewDownloadFile(m, 'ScheduleDocumentsRequired')}
                                                                        style={{}}
                                                                    >
                                                                        {m.fileName}
                                                                    </a>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        fontSize: '12px',
                                                                        color: 'grey',
                                                                        verticalAlign: ''
                                                                    }}
                                                                >
                                                                    {m.uploadedBy} @ {moment(m.uploadedAt).format('LLL')} {`(${m.fileSize})`}
                                                                </div>
                                                            </VehicleStyledTableCell>
                                                            {/* <VehicleStyledTableCell>{m.docName}</VehicleStyledTableCell> */}
                                                        </StyledTableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <PrimaryButton type="submit">
                            {isProforma && salesInvoiceStatus == 'P'
                                ? 'Send Email'
                                : isProforma && salesInvoiceStatus == 'I'
                                  ? 'Create invoice & Email event Document'
                                  : 'Create proforma & Send Email'}
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </form>
            {state.showDocument && (
                <DialogComp title={`Document - ${state.slectedFileName}`} onClose={hideModal('showDocument')} maxWidth="xl" fullWidth fullScreen>
                    <SingleDocumentViewer imageList={state.imageList || []} slectedFileExt={state.slectedFileExt} />
                </DialogComp>
            )}
        </div>
    );
};

export default EmailTemplate;
